
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"254","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('text',{attrs:{"font-family":"Roboto-Regular, Roboto","font-size":"14","fill":"#979797"}},[_c('tspan',{attrs:{"x":"43","y":"25"}},[_v('Cargo Ready Date')])]),_c('g',{attrs:{"fill":"#000","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M30.125 13.25h-.75V12h-1.25v1.25h-8.25V12h-1.25v1.25h-.75A1.877 1.877 0 0016 15.125v11c0 1.034.841 1.875 1.875 1.875h12.25A1.877 1.877 0 0032 26.125v-11a1.877 1.877 0 00-1.875-1.875zm.625 12.875c0 .345-.28.625-.625.625h-12.25a.626.626 0 01-.625-.625v-8.25h13.5v8.25zm0-9.5h-13.5v-1.5c0-.345.28-.625.625-.625h.75v1.25h1.25V14.5h8.25v1.25h1.25V14.5h.75c.345 0 .625.28.625.625v1.5z"}}),_c('path',{attrs:{"d":"M19 19h1v1h-1zM21 19h1v1h-1zM24 19h1v1h-1zM26 19h1v1h-1zM29 19h1v1h-1zM19 22h1v1h-1zM21 22h1v1h-1zM24 22h1v1h-1zM26 22h1v1h-1zM19 24h1v1h-1zM21 24h1v1h-1zM24 24h1v1h-1zM26 24h1v1h-1zM29 22h1v1h-1z"}})]),_c('path',{attrs:{"stroke":"#E1E1E1","d":"M.5.5h253v39H.5z"}})])])
          )
        }
      }
    